import * as React from 'react';
import { useCallback } from 'react';
import Amenities from '../../../Amenities';
import { FlightSegmentStatus } from '@websky/graphql';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import FlightInfo from './FlightInfo/FlightInfo';
import MediaQuery from 'react-responsive';
import { TABLET_MIN_WIDTH } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { InfoMessagePositionsEnum } from '@websky/graphql';
import { useConfig } from '../../../context';
import AircraftLivery from '../../../AircraftLivery';
import InfoMessages from '../../../InfoMessages';
import RouteInfo from './RouteInfo/RouteInfo';
const Segment = props => {
    const { segment: segmentWithTransfer, className, first, last, stops = [], nextDay, renderFlightInfo, multipleSegments, renderPlaneInfo, isReturnFlight } = props;
    const segment = segmentWithTransfer.segment;
    const canceled = segment.status === FlightSegmentStatus.Canceled;
    const iataCode = useConfig().global.companyInfo.iataCode;
    const hasOperatingCarrier = ['A9', 'RM'].includes(iataCode);
    const operationCarrier = hasOperatingCarrier && segment.marketingAirline.iata !== segment.operatingAirline.iata
        ? segment.operatingAirline.name
        : null;
    const theme = useTheme('DesktopFlightRoute').SegmentStyles;
    const { t } = useTranslation('DesktopFlightInfo');
    const renderPlaneInfoHandler = useCallback(() => {
        var _a, _b;
        if (renderPlaneInfo) {
            return renderPlaneInfo(segment);
        }
        return (React.createElement("div", { className: theme.planeInfo },
            React.createElement("div", { className: theme.aircraft }, segment.aircraft.name),
            ((_b = (_a = segment === null || segment === void 0 ? void 0 : segment.flightInfo) === null || _a === void 0 ? void 0 : _a.amenities) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("div", { className: theme.amenities },
                React.createElement(Amenities, { amenities: segment.flightInfo.amenities })))));
    }, [segment, renderPlaneInfo]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: cn(theme.segment, {
                [theme.segment_additional]: !first,
                [theme.canceled]: canceled,
                [theme.oneSegment]: stops.length > 0
            }, className) },
            renderFlightInfo ? (renderFlightInfo({ segment, nextDay, singleFlight: false })) : (React.createElement(FlightInfo, { segment: segment, nextDay: nextDay })),
            React.createElement(RouteInfo, Object.assign({ segmentWithTransfer: segmentWithTransfer, isCanceled: canceled }, props)),
            React.createElement(MediaQuery, { minWidth: TABLET_MIN_WIDTH },
                React.createElement(React.Fragment, null, !canceled ? (React.createElement("div", { className: theme.planeContainer }, segment.aircraft && (React.createElement(React.Fragment, null,
                    React.createElement(AircraftLivery, { className: theme.plane, returnClassName: theme.plane_return, aircraft: segment.aircraft, isReturnFlight: isReturnFlight }),
                    renderPlaneInfoHandler(),
                    operationCarrier && (React.createElement("div", { className: theme.operatingCarrier },
                        t('Operating carrier'),
                        ": ",
                        operationCarrier)))))) : (React.createElement("div", { className: theme.canceled__warning }, t('Canceled')))))),
        !last && multipleSegments && (React.createElement(InfoMessages, { position: InfoMessagePositionsEnum.stopPoint, className: theme.stopPointInfoMessage, itemHtmlClassName: theme.stopPointInfoMessage__htmlMessage, messages: segment.messages })),
        last && multipleSegments && React.createElement("div", { className: theme.totalDuration__decorator })));
};
export default Segment;
